<template>
  <div>

    <el-card :body-style="cardBodyStyle">
      <el-input v-model="query" placeholder="请输入查询条件" size="small" style="width: 200px;"></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="success" size="small" @click="handleSave">保存</el-button>
      <el-button type="danger" size="small" @click="handleClear">清空</el-button>
      <el-button type="primary" plain @click="handleAdd" size="small">新增</el-button>
    </el-card>

    <el-row>
      <el-col :span="6">
       <el-card :body-style="cardBodyStyle">
          <el-table v-loading="loading" :data="tableData" border highlight-current-row
            @row-click="handleCurrentRowChange">
            <el-table-column prop="id" label="编号" width="50" v-if="isShow">
            </el-table-column>
            <el-table-column prop="roleCode" label="角色编码" header-align="center" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="roleName" label="角色名称" header-align="center" align="center" show-overflow-tooltip>
            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center" width="160px">
              <template slot-scope="scope">
                <el-button size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
                <el-button size="mini" plain type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>


          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
            layout=" sizes, prev, pager, next, jumper" :total="totalRows">
          </el-pagination>
        </el-card>
      </el-col>
      <el-col :span="6">
       <el-card :body-style="cardBodyStyle">
          <el-tree :data="dataTree" :props="defaultProps" ref='tree' node-key="id" @check-change="getCheckedNodes"
            show-checkbox @node-click="handleNodeClick" current-node-key accordion
            :default-expanded-keys="menuExpandedKeys">
          </el-tree>
        </el-card>
      </el-col>
      <el-col :span="6">
      <el-card :body-style="cardBodyStyle">
          <el-checkbox-group v-model="checkList">
            <div v-for="item in buttonList" :key="item.id">
              <el-checkbox :label="item.id" @change="handleChange">{{item.buttonName}}</el-checkbox>
            </div>
          </el-checkbox-group>
        </el-card>
      </el-col>


      <el-col :span="6">
      <el-card :body-style="cardBodyStyle">
          <div v-if="role.id!=null">当前角色：{{role.roleName}}
          </div>
          <div v-else>未选择角色
          </div>

          <div v-if="menu.id!=null&&role.id!=null">当前菜单：{{menu.text}};配置该菜单数据权限
          </div>
          <div v-else-if="menu.id==null&&role.id!=null">未选择菜单,配置角色通用数据权限
          </div>
          <div v-else>未选择菜单
          </div>


          <div>
            <el-radio-group v-model="personalFlag" @change="personalFlagChange">
              <el-radio label="0">按部门</el-radio>
              <el-radio label="1">按个人</el-radio>
            </el-radio-group>
          </div>
          <div>
            <el-radio-group v-model="defaultFlag" @change="defaultFlagChange">
              <el-radio label="0">角色权限</el-radio>
              <el-radio label="1" disabled>菜单权限</el-radio>
            </el-radio-group>
          </div>
          <el-tree :data="departmentTree" :props="defaultPropsDepartment" node-key="id" show-checkbox accordion
            ref='department' :expand-on-click-node="false" :default-expanded-keys="departmentExpandedKeys">
          </el-tree>
        </el-card>
      </el-col>
    </el-row>





    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="dialogVisible" width="400px">
      <el-form :model="sysRole" label-position="right" label-width="80px">
        <!-- <el-form-item label="编码">
    			<el-input v-model="sysRole.id" placeholder=""></el-input>
    		</el-form-item> -->
        <el-form-item label="角色编码">
          <el-input v-model="sysRole.roleCode" size="small"></el-input>
        </el-form-item>
        <el-form-item label="角色名称">
          <el-input v-model="sysRole.roleName" size="small"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer">
        <el-button type="success" size="small" @click="handleSaveRole">保存</el-button>
        <el-button type="danger" size="small" @click="handleCancelSaveRole">取消</el-button>
      </span>

    </el-dialog>




  </div>
</template>
<script>
  import axios from '@/axios'
    import tools from '@/tools'
  export default {
    data() {
      return {
   cardBodyStyle: tools.style.card,
        query: '',
        sysRole: {
          id: '',
          roleCode: '',
          roleCode: '',
          roleName: '',
          roleName: '',
        },
        loading: true,
        dialogVisible: false,




        dataTree: [],
        menuExpandedKeys: [],
        defaultProps: {
          children: 'children',
          label: 'text'
        },
        defaultPropsDepartment: {
          children: 'children',
          label: 'deptName'
        },
        checkedMenuIdLeaf: [],
        checkedMenuId: [],
        halfCheckMenuId: [],
        //表格初始化参数
        tableData: [],
        currentPage: 1,
        totalRows: 0,
        pageSizes: [10, 20, 50, 100],
        pageSize: 10,
        //查询条件
        queryRoleName: '',

        isShow: false,
        loading: true,
        loadingTree: true,


        role: {},
        menu: {},
        buttonList: [],
        checkList: [],


        departmentTree: [],
        departmentExpandedKeys: [],

        personalFlag: '0',
        defaultFlag: '0',
      }
    },
    //界面渲染完毕调用   初始化表格参数
    mounted() {
      this.getTableData()
      this.getDataTree()
      this.getDepartmentTree()
    },
    methods: {
      // 获取table数据
      getTableData() {
        //console.log("获取table数据getTableData")
        var url = 'framework/SysRole/query.do'
        var param = {
          page: this.currentPage,
          rows: this.pageSize,
          roleName: this.query
        }
        axios.get(url, param).then(response => {
          this.tableData = response.data.data.list
          this.totalRows = response.data.data.total
          if (response) {
            this.loading = false
          } else {
            this.loading = true
          }
        });
      },
      // 修改每页条数事件
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize = val
        this.getTableData()
      },
      // 修改当前页事件
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val
        this.getTableData()
      },
      search() {
        this.getTableData()
      },
      getDataTree() {
        var url = 'framework/SysParent/queryMenu.do '
        var param = {}
        axios.get(url, param).then(response => {
          this.dataTree = response.data.data

          if (this.dataTree.length == 1) {
            for (var node of this.dataTree) {
              this.menuExpandedKeys.push(node.id)
            }
          }

        });
      },
      handleCurrentRowChange(val) {
        this.role = val
        var url = 'framework/SysRoleMenu/queryByRoleIdOnlyLeaf.do'
        var param = {
          roleId: this.role.id
        }
        axios.get(url, param).then(response => {

          var str = response.data.data.toString()

          var bool1 = str.indexOf(",")
          if (bool1 != -1) {
            this.$refs.tree.setCheckedKeys(str.split(","))
          } else {
            var arr = [str]
            this.$refs.tree.setCheckedKeys(arr)
          }

        });

        this.getMenuButton()
        this.getRoleMenuButton()
        this.getPermission()
      },

      getCheckedNodes(data, checked, indeterminate) {
        this.checkedMenuIdLeaf = this.$refs.tree.getCheckedKeys('true')
        this.checkedMenuId = this.$refs.tree.getCheckedKeys()
        this.halfCheckMenuId = this.$refs.tree.getHalfCheckedKeys()
      },
      handleSave() {

        var checkDepartmentId = this.$refs.department.getCheckedKeys()

        var url = 'framework/SysRoleMenu/save.do'
        var param = {
          roleId: this.role.id,
          menuId: this.menu.id,

          checkedMenuIdLeaf: this.checkedMenuIdLeaf.join(','),
          checkedMenuId: this.checkedMenuId.join(','),
          halfCheckMenuId: this.halfCheckMenuId.join(','),

          checkedButton: this.checkList.join(','),
          checkedDepartment: checkDepartmentId.join(','),
          personalFlag: this.personalFlag,
          defaultFlag: this.defaultFlag
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$message({
              type: 'success',
              message: '保存成功!',
            });

          } else {
            this.$message({
              type: 'error',
              message: '保存失败' + response.data.msg,
            });
          }

        });
      },

      getMenuButton() {
        var url = 'framework/SysMenu/queryMenuButton.do'
        var param = {
          menuId: this.menu.id
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.buttonList = response.data.data
          } else {
            this.$message({
              type: 'error',
              message: '操作失败' + response.data.msg,
            });
          }
        });
      },

      getRoleMenuButton() {
        var url = 'framework/SysRoleMenu/queryRoleMenuButton.do'
        var param = {
          roleId: this.role.id,
          menuId: this.menu.id
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.checkList = response.data.data
          } else {
            this.$message({
              type: 'error',
              message: '操作失败' + response.data.msg,
            });
          }
        });
      },

      handleNodeClick(data) {
        console.log(JSON.stringify(data))
        this.menu = data
        if (this.role.id != '' && this.menu.id != '' && data.children.length == 0) {
          this.getMenuButton()
          this.getRoleMenuButton()
          this.getPermission()
          this.defaultFlag = '1'
        } else {
          this.buttonList = []
        }


      },
      handleChange() {
        // console.log(this.checkList)
      },



      getDepartmentTree() {
        var url = 'framework/SysDepartment/queryTree.do?fid=0'
        var param = {}
        axios.get(url, param).then(response => {
          this.departmentTree = response.data.data
          if (this.dataTree.length == 1) {
            for (var node of this.departmentTree) {
              this.departmentExpandedKeys.push(node.id)
            }
          }
        });
      },

      getPermission() {
        var url = 'framework/SysRoleMenu/queryPermission.do'
        var param = {
          roleId: this.role.id,
          menuId: this.menu.id
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            if (response.data.data != 'noPermission') {
              this.personalFlag = response.data.data.personalFlag
              this.defaultFlag = response.data.data.defaultFlag
              this.$refs.department.setCheckedKeys(response.data.data.checkedDepartment)
            } else {
              this.personalFlag = '2'
              if (this.menu.id == null || this.menu.id == '') {
                this.defaultFlag = '0'
              } else {
                this.defaultFlag = '1'
              }

              this.$refs.department.setCheckedKeys([])
            }
          } else {
            this.$message({
              type: 'error',
              message: '操作失败' + response.data.msg,
            });
          }
        });
      },
      test() {
        var list = this.$refs.department.getCheckedKeys()

      },

      personalFlagChange() {

      },
      defaultFlagChange(value) {
        if (value == '0') {
          this.menu = {}
          this.$refs.department.setCheckedKeys([])
          this.buttonList = []

        } else if (value == '1') {

        }
      },

      handleClear() {
        this.personalFlag = '2'
        this.defaultFlag = '2'
        this.role = {}
        this.menu = {}
        this.buttonList = []
        this.$refs.department.setCheckedKeys([])
        this.$refs.tree.setCheckedKeys([])
      },




      handleAdd() {
        this.dialogVisible = true
        this.sysRole = {
          id: '',
          roleCode: '',
          roleName: '',
        }

        var url = 'framework/SysRole/queryNewCode.do'
        var param = {}
        axios.get(url, param).then(response => {
          this.sysRole.roleCode = response.data.data.code
          this.sysRole.roleName = response.data.data.code
        });
      },

      handleEdit(row) {
        this.dialogVisible = true
        this.sysRole = row

      },

      handleDelete(id) {
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var url = 'framework/SysRole/remove.do'
          var param = {
            id: id
          }
          axios.post(url, param).then(response => {
            if (response.data.code == '0') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getTableData()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!' + response.data.msg
              });
            }

          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      handleCancelSaveRole(row) {
        this.dialogVisible = false
      },

      handleSaveRole(row) {
        var url = 'framework/SysRole/save.do'
        var json = JSON.stringify(this.sysRole)
        var param = {
          json: json
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            this.getTableData()
            this.dialogVisible = false
          } else {
            this.$message({
              type: 'error',
              message: '操作失败!' + response.data.msg
            });
          }
        });
      },










    },
  }
</script>
<style>
  .rolemenu-role {
    width: 30%;
    height: 100%;
    float: left;
  }

  .rolemenu-menu {
    width: 65%;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/view/system/rolemenu.vue